<script>import { twMerge } from 'tailwind-merge';
import { clickOutside } from '../../actions';
import { get_current_component, setContext } from 'svelte/internal';
import { forwardEventsBuilder, useActions } from '../../actions';
export let use = [];
import { exclude } from '../../utils/exclude';
const forwardEvents = forwardEventsBuilder(get_current_component());
export let visible = false;
function handleClose() {
    visible = false;
}
setContext('dropdown-handleClose', handleClose);
const defaultClass = 'relative inline-block stwui-dropdown';
$: finalClass = twMerge(defaultClass, $$props.class);
</script>

<div
	class={finalClass}
	use:clickOutside={handleClose}
	use:useActions={use}
	use:forwardEvents
	{...exclude($$props, ['use', 'class'])}
>
	<div class="floating-ui-ref">
		<slot name="trigger" />
	</div>
	{#if visible}
		<slot name="items" />
	{/if}
</div>
